export default "__VITE_ASSET__e054b1cd__$_?component__"